import axionIns from "../axios";

const getPayment = async (page, perPage) => {
  return axionIns.get(`admin/payments?page=${page}&perPage=${perPage ? perPage : 10}`).then((response) => { return response.data });
};

const updatePaymentStatus = async (id, payload) => {
  return axionIns.put("admin/payments/" + id, JSON.stringify(payload)).then((response) => { return response.data });
};

const updatePaymentApprovalStatus = async (id, payload) => {
  return axionIns.put("admin/paymentsapproval/" + id, JSON.stringify(payload)).then((response) => { return response.data });
};

const getPaidUpCapital = async (page, limit, companyId = "") => {
  const companyFilter = companyId ? `&companyId=${companyId}` : "";
  return axionIns.get(`admin/capital/paid?page=${page}&limit=${limit}${companyFilter}`).then((response) => { return response.data });
};

const approvePaidUpCapital = async (payload) => {
  return axionIns.post("admin/capital/paid", JSON.stringify(payload)).then((response) => { return response.data });
};

const exportOject = {
  getPayment,
  updatePaymentStatus,
  updatePaymentApprovalStatus,
  getPaidUpCapital,
  approvePaidUpCapital
};

export default exportOject;
